import React, { useState } from "react";
import {
  useStates,
  useConstituencies,
} from "../../hooks/useStatesAndConstituencies";
import { useTranslation } from "react-i18next";

function SelectConstituency() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    state: "",
    constituency: "",
  });

  const stateList = useStates();
  const constituencyList = useConstituencies(formData.state);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let newErrors = {};

    if (!formData.state.trim()) {
      newErrors.state = "Please select state.";
    }

    if (!formData.constituency.trim()) {
      newErrors.constituency = "Please select constituency.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    setTimeout(() => {
      setLoading(false);

      localStorage.setItem("stateId", formData.state);
      localStorage.setItem("constituencyId", formData.constituency);

      window.location.href = "/game-list";
    }, 500);
  };

  return (
    <>
      <section className="my-logo-box d-flex justify-content-center align-items-center gap-3 mt-2">
        <div className="main-logos">
          <img
            src={`${process.env.PUBLIC_URL}/img/file-manager/fit_india.png`}
            alt="fit_india"
          />
        </div>
        <div className="main-logos">
          <img
            src={`${process.env.PUBLIC_URL}/img/file-manager/khelo_india.png`}
            alt="khelo_india"
          />
        </div>
      </section>

      <section className="d-flex justify-content-center mt-3 px-3">
        <form method="post" onSubmit={handleSubmit} noValidate>
          <div
            className="card shadow-sm p-4"
            style={{ maxWidth: 600, width: "100%" }}
          >
            <h2 className="text-center fw-semibold mb-4">
              {t('select_constituency')}
            </h2>
            <div className="row g-3">
              <div className="col-md-6">
                <select
                  name="state"
                  className={`form-select ${errors.state ? "is-invalid" : ""}`}
                  value={formData.state}
                  onChange={handleChange}
                >
                  <option value="">{t('select_state')}</option>

                  {stateList &&
                    stateList.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.state}
                      </option>
                    ))}
                </select>
                {errors.state && (
                  <div className="invalid-feedback d-block">{errors.state}</div>
                )}
              </div>
              <div className="col-md-6">
                <select
                  name="constituency"
                  className={`form-select ${
                    errors.constituency ? "is-invalid" : ""
                  }`}
                  value={formData.constituency}
                  onChange={handleChange}
                >
                  <option value="">{t('select_constituency')}</option>
                  {constituencyList &&
                    constituencyList.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.constituency}
                      </option>
                    ))}
                </select>
                {errors.constituency && (
                  <div className="invalid-feedback d-block">
                    {errors.constituency}
                  </div>
                )}
              </div>
            </div>
            <button
              type="submit"
              className="btn mt-3 btn-primary w-100"
              disabled={loading}
            >
              {/* {loading ? "Checking..." : "Check Details"} */}
              {t('check_details')}
            </button>
          </div>
        </form>
      </section>

      <section className="container my-5">
        <div className="row g-4 text-center">
          <div className="col-md-4 col-sm-6">
            <div className="card shadow-sm highlight-box p-4">
              <div className="fs-1 text-warning">🏆</div>
              <h5 className="mt-3 fw-semibold">{t('sports_competition')}</h5>
              <p className="text-muted small">
                {t('sports_competition_subtitle')}
              </p>
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div className="card shadow-sm highlight-box p-4">
              <div className="fs-1 text-primary">📅</div>
              <h5 className="mt-3 fw-semibold">{t('event_schedule')}</h5>
              <p className="text-muted small">
                {t('event_schedule_subtitle')}
              </p>
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div className="card shadow-sm highlight-box p-4">
              <div className="fs-1 text-success">👥</div>
              <h5 className="mt-3 fw-semibold">{t('youth_participation')}</h5>
              <p className="text-muted small">{t('youth_participation_subtitle')}</p>
            </div>
          </div>
          {/* <div className="col-md-3 col-sm-6">
            <div className="card shadow-sm highlight-box p-4">
              <div className="fs-1 text-danger">▶</div>
              <h5 className="mt-3 fw-semibold">{t('live_highlights')}</h5>
              <p className="text-muted small">Watch live updates and videos</p>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default SelectConstituency;
